export function format(str, data) {
	if (!data || !str) return str //do not format if empty
	if(str.indexOf("{") < 0) return str //do not format if no placeholder found

	return str.replace(/\{([a-zA-Z0-9]{1,15})\}/g, (match, g1) => {
		let val = data[g1]
		if(val != undefined) {
			return val
		} else {
			return ""
		}
	})
}

export function formatLines (lines, separator = '<br>') {
  return lines.filter(line => line?.toString?.()?.trim?.()).join(separator)
}

export function formatAddress(address, { separator = '<br>', exclude = [] } = {}) {
  const formattedAddress = []
  const rawAddress = Object.entries(address).reduce((a, [key, value]) => {
    if (!exclude.includes(key)) {
      a[key] = value
    }
    return a
  }, {})

  if (address) {
    formattedAddress.push(formatLines([rawAddress.firstName, rawAddress.lastName], ' '))

    if (rawAddress.street || rawAddress.streetNumber) {
      formattedAddress.push(formatLines([rawAddress.street, rawAddress.streetNumber], ' '))
    }

    if (rawAddress.postcode || rawAddress.city) {
      formattedAddress.push(formatLines([rawAddress.postcode, rawAddress.city], ' '))
    }

    if (rawAddress.phoneNumber) {
      formattedAddress.push(`☎ ${rawAddress.phoneNumber}`);
    }

    if (rawAddress.company) {
      formattedAddress.unshift(rawAddress.company);
    }

    if (rawAddress.details) {
      formattedAddress.push(`<small>${rawAddress.details}</small>`);
    }
  }

  return formattedAddress.join(separator);
}
